import * as Yup from 'yup'

const validateDisplayName = () =>
  Yup.string()
    .matches(/^(?!\s)/, `Can't start with space`)
    .matches(/^(.){3,30}$/, 'Should contain from 3 to 30 characters')
    .matches(/^[a-zA-Z0-9\-\_\.\ ]+$/, 'Contains invalid characters')

export { validateDisplayName }
